// const GOOGLE_CLIENT_ID_DEV = "86533363579-3rv7e4djq5idja7rejpiitlhssidjspm.apps.googleusercontent.com";
const GOOGLE_CLIENT_ID_PROD = "888311011638-8cn4ie0as7pi7r4qhhavcrm3cn92m992.apps.googleusercontent.com";
export const GOOGLE_CLIENT_ID = GOOGLE_CLIENT_ID_PROD;
